<div mat-dialog-title>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="position: relative;margin-top: 20px;">
    <div class="close-dialog" mat-dialog-close style="display: none;">
      <span class="material-symbols-outlined">close</span>
    </div>
  </div>
</div>



<mat-dialog-content>

  <div style="text-align: center;">

    <div style="text-align: center;margin-bottom: 60px;margin-top: 40px;">
      @if (!sii_lento) {
        <span><span class="material-symbols-outlined" style="font-size: 65px;color:var(--simpli-color7)">check_circle</span></span>
      }
      @if (sii_lento) {
        <span><span class="material-symbols-outlined" style="font-size: 65px;color:var(--simpli-color8)">error</span></span>
      }
    </div>

    <div class="label-dialog-strong">{{title}}</div>
    <div class="label-dialog">{{subtitle}}</div>


    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

        <div class="btn-simpli-container">
          @if (!sii_lento) {
            <button class="primary-button" mat-flat-button (click)="ver_estado()">
              Ver estado
            </button>
          }

          @if (sii_lento) {
            <button class="primary-button" mat-flat-button (click)="retry()">
              Reintentar
            </button>
          }
        </div>

      </div>
    </div>

  </div>



</mat-dialog-content>